// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.challenge-name {
  display: flex;
  justify-content: start;
  padding: 0px 24px;
  column-gap: 8px;
  align-items: center;
}
.challenge-name span {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #757575;
}
.loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.scrollable-content {
  overflow: auto;
  height: 80vh;
}
.action-button-section {
  display: flex;
  justify-content: space-between;
  padding: 12px 24px;
  position: relative;
  z-index: 10;
  flex-wrap: wrap;
  gap: 12px;
}
.action-button-section .buttonContainer .MuiButton-root.Mui-disabled {
  background-color: #e0e0e0;
  color: #9e9e9e;
}
.cancel-box,
.add-box {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

/* Responsive sizing for action button section */
@media (max-width: 768px) {
  .action-button-section {
    padding: 8px 12px;
    gap: 8px;
  }
  .cancel-box,
  .add-box {
    gap: 8px;
  }
  .action-button-section button {
    font-size: 0.75rem !important;
    padding: 6px 12px !important;
  }
}

@media (max-width: 480px) {
  .action-button-section {
    padding: 8px 8px;
    gap: 6px;
    flex-direction: column;
  }
  .cancel-box,
  .add-box {
    gap: 6px;
    width: 100%;
  }
  .action-button-section button {
    font-size: 0.65rem !important;
    padding: 4px 8px !important;
  }
}

@media (min-width: 1920px) {
  .action-button-section {
    max-width: 100%;
  }
  .cancel-box,
  .add-box {
    max-width: 50%;
  }
  .action-button-section button {
    font-size: 1rem !important;
  }
}
.add-box
  button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-colorPrimary.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-colorPrimary.button_type_button.btn--primary.dPSButtonComponentSection {
  column-gap: 6px;
}

/* Ensure menu appears above content */
#add-notes-menu {
  z-index: 1300;
}

.MuiMenu-root {
  z-index: 1300 !important;
}

.MuiPopover-root {
  z-index: 1300 !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/custom/viewChallenge/AgentViewChallenge.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;;IAEE,QAAQ;EACV;EACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,QAAQ;IACR,sBAAsB;EACxB;EACA;;IAEE,QAAQ;IACR,WAAW;EACb;EACA;IACE,6BAA6B;IAC7B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;;EAEE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".challenge-name {\n  display: flex;\n  justify-content: start;\n  padding: 0px 24px;\n  column-gap: 8px;\n  align-items: center;\n}\n.challenge-name span {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #757575;\n}\n.loading-indicator {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.scrollable-content {\n  overflow: auto;\n  height: 80vh;\n}\n.action-button-section {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 24px;\n  position: relative;\n  z-index: 10;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n.action-button-section .buttonContainer .MuiButton-root.Mui-disabled {\n  background-color: #e0e0e0;\n  color: #9e9e9e;\n}\n.cancel-box,\n.add-box {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* Responsive sizing for action button section */\n@media (max-width: 768px) {\n  .action-button-section {\n    padding: 8px 12px;\n    gap: 8px;\n  }\n  .cancel-box,\n  .add-box {\n    gap: 8px;\n  }\n  .action-button-section button {\n    font-size: 0.75rem !important;\n    padding: 6px 12px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .action-button-section {\n    padding: 8px 8px;\n    gap: 6px;\n    flex-direction: column;\n  }\n  .cancel-box,\n  .add-box {\n    gap: 6px;\n    width: 100%;\n  }\n  .action-button-section button {\n    font-size: 0.65rem !important;\n    padding: 4px 8px !important;\n  }\n}\n\n@media (min-width: 1920px) {\n  .action-button-section {\n    max-width: 100%;\n  }\n  .cancel-box,\n  .add-box {\n    max-width: 50%;\n  }\n  .action-button-section button {\n    font-size: 1rem !important;\n  }\n}\n.add-box\n  button.MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-colorPrimary.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeMedium.MuiButton-textSizeMedium.MuiButton-colorPrimary.button_type_button.btn--primary.dPSButtonComponentSection {\n  column-gap: 6px;\n}\n\n/* Ensure menu appears above content */\n#add-notes-menu {\n  z-index: 1300;\n}\n\n.MuiMenu-root {\n  z-index: 1300 !important;\n}\n\n.MuiPopover-root {\n  z-index: 1300 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
